// extracted by mini-css-extract-plugin
module.exports = {"carBrand":"CarBrand","carBrandImage":"CarBrand-image","carBrandText":"CarBrand-text"};